import { useParams } from "react-router-dom";
import MacroEditView from "./../components/MacroEditView.react";

export default function MacroEditViewRoute(): React$Element<any> {
  return <MacroEditView />;
}
